import endPoints from 'utils/endPoints';
import { GetMutate, PostMutate, PutMutate } from 'utils/mutationAndQuery/customMutation';


export const fetchSales = () => {
  const { data, isPending, isSuccess, mutate } = PostMutate(
    endPoints.fetchAllSales
  );
  return {
    isLoading: isPending,
    sales: data?.data ?? [],
    message: data?.message,
    isSuccess,
    mutate,
  };
};

export const sellProduct = () => {
  const {   data, isPending, isSuccess, mutate, isError, clearData, error } = PostMutate(
    endPoints.sellItem,
    endPoints.fetchAllSales
  );

  return {
    loading: isPending,
    previewData: data?.data ?? [],
    message: data?.message || data,
    isSuccess,
    isError,
    mutate,
    clearData,
  };
};

export const fetchClients = () => {
  const { data, isPending, isSuccess, mutate } = PostMutate(
    endPoints.fetchCustomers
  );
  return {
    isLoading: isPending,
    clients: data?.data ?? [],
    message: data?.message,
    isSuccess,
    mutate,
  };
};

export const fetchProductItems = () => {
  const { data, isPending, isSuccess, mutate } = PostMutate(
    endPoints.fetchAllProducts
  );
  return {
    isLoading: isPending,
    productItem: data?.data ?? [],
    message: data?.message,
    isSuccess,
    requestProductList: mutate,
  };
};


export const fetchAllLoans = () => {
  const { data, isPending, isSuccess, mutate } = PostMutate(
    endPoints.fetchLoans
  );
  return {
    isLoadingLoans: isPending,
    loansData: data?.data ?? [],
    message: data?.message,
    isSuccess,
    requestLoanData: mutate,
  };
};


export const requestLoanPayment = () => {
  const { data, isPending, isSuccess, mutate, clearData, isError, error } = PutMutate(
    endPoints.loanPayment
  );
  return {
    isLoadingPayment: isPending,
    loanPaymentData: data?.data ?? [],
    loanPaymentResponse: data?.message,
    successPaymentRequest: isSuccess,
    errorPaymentRequest: isError,
    paymentErrorData: error,
    requestPayment: mutate,
    clearRequestPayment: clearData
  };
};


export const requestDeleteSale = () => {
  const { data, isPending, isSuccess, mutate, clearData } = PutMutate(
    endPoints.deleteSale
  );
  return {
    loadRemovedSale: isPending,
    removeSaleData: data?.data ?? [],
    removeSaleResponse: data?.message,
    successSaleRemoved: isSuccess,
    requestRemoveSale: mutate,
    clearRemoveSale: clearData
  };
};


export const useCreateClient = () => {
  const { data, isPending, isSuccess, mutate, clearData } = PostMutate(
    endPoints.createClient
  );
  return {
    loadingCreateClient: isPending,
    createClientData: data?.data ?? null,
    createClientResponse: data?.message,
    successCreateClient: isSuccess,
    requestCreateClient: mutate,
    clearCreateClient: clearData
  };
};

export const requestLoanPaymentHistory = () => {
  const { data, isPending, isSuccess, mutate, clearData } = PostMutate(
    endPoints.loanPaymentHistory
  );
  return {
    loadingPaymentHistorySale: isPending,
    loanPaymentHistoryData: data?.data ?? [],
    loanPaymentHistoryResponse: data?.message,
    successSaleRemoved: isSuccess,
    getLoanPaymentHistory: mutate,
    clearLoanPaymentHistory: clearData
  };
};

export const fetchReceiptDetails = (txnNumber: string | number) => {
  const { data, isPending, isSuccess, mutate, isError, error } = GetMutate(
    endPoints.getReceiptDetails(txnNumber)
  );
  return {
    isLoading: isPending,
    receiptData: data ?? null,
    message: data?.message,
    isSuccess,
    isError,
    error,
    getReceipt: mutate,
  };
};